import { Row, Col, Button } from 'reactstrap';
import Layout from '../../layout';
import SideBar from '../../global/Components/SideBar/SideBar';
import useWindowSize from '../../global/utils/hooks/useWindowSize';
import Navigation from './Sections/Navigation';
import { Outlet } from 'react-router-dom';
import ResendEmail from '../LoginPage/ResendEmail/ResendEmail';
import { Sidebar } from 'primereact/sidebar';
import { useToggle } from '../../global/utils/hooks/useToggle';
import { useState, useEffect, useRef } from 'react';
import useApiPrivate from '../../global/utils/hooks/useApiPrivate';
import SEO from '../../global/Components/SEO/SEO';
import { Toast } from 'primereact/toast';

const  USER_URL = 'api/v1/user';

export default function Dashboard() {
    const { width } = useWindowSize();
    const apiPrivate = useApiPrivate();
    const [isOffCanvas, setIsOffCanvas, toggleIsOffCanvas] = useToggle(false);
    const toast = useRef(null);

    const [user, setUser] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const callUser = async () => {
        setIsLoading(true);

        try {
            const response = await apiPrivate(USER_URL);
            setIsLoading(false);
            setUser(response.data.data);
        }
        catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message);
            }         }
            setIsLoading(false);
    }

    let colSize = {
        xs: 12,
        sm: 12,
        md: 3
    }

    let colContentSize = {
        xs: 12,
        sm: 12,
        md: 9
    }

    if (width <= 1024) {
        colSize = {
            xs: 12,
            sm: 12,
            md: 12
        }
        colContentSize = {
            xs: 12,
            sm: 12,
            md: 12
        }
    }

    const handleOffCanvas = () => {
        setIsOffCanvas(false);
    }

    useEffect(() => {
        callUser();
    },[]);

    return (
        <>
            <Layout>
                <SEO title={'Dashboard'} />
                <Toast ref={toast} position="top-center" />

                <div className="container-xxl">
                    {
                        width < 1025 || !user.email_verified_at ?
                            <Row className={`${width < 1025 ? 'pt-3' : 'pt-5'}`}>
                                {
                                    width < 1025 &&
                                        <Col>
                                            <div>
                                                <Button
                                                    onClick={toggleIsOffCanvas}
                                                >
                                                    <i className="bi bi-list"></i>
                                                </Button>
                                            </div>
                                        </Col>
                                }
                                {
                                    !isLoading && user.email_verified_at == null &&
                                        <Col xs={12} className={`${width < 1025 ? 'mt-3' : ''}`}>
                                            <ResendEmail />
                                        </Col>
                                }
                            </Row>
                            : ''
                    }
                    <Row className={`${width < 1025 ? 'pt-3 ww' : 'pt-5'} pb-3`}>
                        {
                            width < 1025
                                ? <>
                                    <Sidebar visible={isOffCanvas} onHide={toggleIsOffCanvas}>
                                        <Navigation user={user} onCloseOffCanvas={handleOffCanvas} width={width} />
                                    </Sidebar>
                                </>
                                : <>
                                    <SideBar xs={colSize.xs} sm={colSize.sm} md={colSize.md}>
                                        <Navigation user={user} />
                                    </SideBar>
                                </>
                        }
                        {
                            <Col xs={colContentSize.xs} sm={colContentSize.sm} md={colContentSize.md}>
                                <Outlet />
                            </Col>
                        }
                    </Row>
                </div>
            </Layout>
        </>
    )
}
